export const ENTRY_DATA_LICENSOR_TABLE = "Licensor Table";

export const ENTRY_DATA_LICENSOR_TABLE_KEYS = {
  licensorName: "Licensor Name",
  licensorResponsibilityRights: "Licensor Responsibility & Rights",
} as const;
